import Button from 'app/components/Button';
import MetamaskIcon from 'app/components/icons/MetamaskIcon';
import NasLogoIcon from 'app/components/icons/NasLogoIcon';
import Modal from 'app/components/Modal';
import React from 'react';
import style from './NftSuccessModal.module.scss';

type NftSuccessModalProps = {
  address?: string | null;
  walletType?: string;
  open?: boolean;
  onSuccess?: (...args: any[]) => void;
};

const walletIcon = {
  metamask: <MetamaskIcon />,
  naswallet: <NasLogoIcon />,
};

const NftSuccessModal = ({
  address,
  open,
  onSuccess,
  walletType,
}: NftSuccessModalProps) => {
  const className = 'c-NftSuccessModal';

  const concatenatedAddress = `${address?.substr(0, 5)}....${address?.slice(
    -5,
  )}`;
  // @ts-ignore
  const icon = walletIcon?.[walletType] ?? null;

  return (
    <Modal
      open={open}
      onClose={() => {}}
      showCloseIcon={false}
      customContainerClass={style[`${className}__modal`]}
    >
      <div className={style[className]}>
        <p className={style[`${className}__title`]}>
          You have successfully claimed your certificate!
        </p>
        <p className={style[`${className}__body`]}>
          Your certificate has been transferred to the wallet address as shown
          below
        </p>
        <p className={style[`${className}__info`]}>
          {icon}
          <span>Wallet:</span>
          {concatenatedAddress}
        </p>
        <div className={style[`${className}__card`]}>
          Note: You can access your tokens/certificates via the learning portal
          or Nas IO website.
        </div>
        <div className={style[`${className}__cta`]}>
          {/* @ts-ignore */}
          <Button displayType="primary" onClick={onSuccess}>
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default NftSuccessModal;
